import React from 'react';
import {InsightInterval, OperatorFeedbackInsight} from "types/OperatorInsights";
import {ChartData, ChartOptions} from "chart.js";
import {toTitleCase} from "services/string";
import {Line as LineChart} from "react-chartjs-2";
import HoverAnnotation from "../../../plugins/hover-annotation";
import {FeedbackSubjectType} from "../../../types/FeedbackSubjectType";

type Props = {
    data: OperatorFeedbackInsight
    interval: InsightInterval
    compare: InsightInterval
    subjectType: FeedbackSubjectType
}

function FeedbackChart({compare, data, interval, subjectType}: Props) {

    const chartData: ChartData<'line', any> = {
        labels: data.metrics.map(metric => metric.time),
        datasets: [
            // All
            {
                label: "All Feedback (Current period)",
                backgroundColor: "rgba(99, 102, 241, 0.8)",
                borderColor: "rgba(79, 70, 229, 1)",
                pointBackgroundColor: "rgba(99, 102, 241, 1)",
                data: data.metrics.map(metric => metric.measurements[`${subjectType}_feedback`].value),
            },
            {
                label: `All Feedback (Previous ${compare})`,
                backgroundColor: "rgba(99,102,241,0.4)",
                borderColor: "rgba(79, 70, 229, 0.4)",
                pointBackgroundColor: "rgba(99, 102, 241, 0.4)",
                data: data.metrics.map(metric => metric.measurements[`${subjectType}_feedback`].comparison),
            },

            // Positive
            {
                label: "Positive Feedback (Current period)",
                backgroundColor: "rgba(82,209,74,0.8)",
                borderColor: "rgb(121,222,114, 1)",
                pointBackgroundColor: "rgba(82,209,74,1)",
                data: data.metrics.map(metric => metric.measurements[`${subjectType}_positive_feedback`].value),
            },
            {
                label: `Positive Feedback (Previous ${compare})`,
                backgroundColor: "rgba(82,209,74,0.4)",
                borderColor: "rgb(121,222,114, 0.4)",
                pointBackgroundColor: "rgba(82,209,74,0.4)",
                data: data.metrics.map(metric => metric.measurements[`${subjectType}_positive_feedback`].comparison),
            }
        ],
    }

    const chartOptions: ChartOptions<'line'> = {
        plugins: {
            legend: {
                display: true,
            },
            tooltip: {
                mode: "index",
                intersect: false,
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: toTitleCase(interval)
                },
            },
            y: {
                title: {
                    display: true,
                    text: `${toTitleCase(subjectType)} Feedback`
                },
                grid: {
                    display: true
                },
                min: 0
            }
        }
    }

    return (
        <LineChart data={chartData} options={chartOptions} plugins={[HoverAnnotation]}/>
    );
}

export default FeedbackChart;